import _ from 'lodash';
import React from 'react';
import { FiPlus, FiSearch } from 'react-icons/fi';
import { CircleSpinner } from 'react-spinners-kit';
import styled from 'styled-components';
import { useUserRoles } from '../../../util/use-user-role';
import { DashboardHeader } from '../../core/DashboardHeader';
import { DashboardWrapper } from '../../core/DashboardWrapper';
import { HorizontalContent } from '../../core/HorizontalContent';
import { Can } from '../../core/rbac/Can';
import { RhButton } from '../../core/RhButton';
import { RhCard } from '../../core/RhCard';
import { RhCardListItem } from '../../core/RhCardListItem';
import { RhInput } from '../../core/RhInput';
import { RhTag } from '../../core/RhTag';
import { SectionListPagination } from '../../core/SectionListPagination';
import { colors, H2 } from '../../core/Styles';
import { EventsProps } from '../containers/EventsContainer';

export const EventsScreen: React.FC<EventsProps> = props => {
  // It's counter-intuitive to put this on the container
  const { roles } = useUserRoles();

  return (
    <DashboardWrapper>
      <DashboardHeader
        title="Events"
        // title={
        //   // content filter - disabled for now
        //   <RhTabBar
        //     activeId={props.currentTabId}
        //     tabs={props.tabs}
        //     onSelect={props.userSelectedTab}
        //   // />
        // }
      />
      <Grid>
        <Section>
          <RhCard>
            <HorizontalContent
              left={<H2>Scheduled Events</H2>}
              right={[
                props.loading && <CircleSpinner key="spinner" size={15} color={colors.primary} />,
                <RhInput
                  icon={FiSearch}
                  onChange={e => {
                    props.userUpdatedScheduledLiveEventsSearchField(e.target.value);
                  }}
                  key="events-search"
                  placeholder="Search"
                />,
                <Can
                  key="events-add"
                  role={roles?.[0]}
                  perform="create:events"
                  yes={<RhButton title="Add" suffixIcon={FiPlus} onClick={props.userClickedAddEvent} />}
                />,
              ]}
            />
            {!!props.scheduledEvents.length && (
              <Events>
                {props.scheduledEvents.map(event => (
                  <RhCardListItem
                    isHoverable
                    key={event.id}
                    imageUrl={event.featuredImage.url}
                    startTime={event.startTime}
                    title={event.title}
                    authorLabelOverride="Lead by:"
                    author={_.startCase(event.leader?.name)}
                    dateUpdated={event.dateUpdated}
                    description={event.description}
                    onClick={() => props.userClickedAnEvent(event.id)}
                    topRightActions={
                      event.publishingStatus === 'unpublished' ? <RhTag editable={false} title="Unpublished" /> : null
                    }
                  />
                ))}
              </Events>
            )}
            <SectionListPagination
              loading={props.loading}
              currentPage={props.scheduledPage}
              hasNextPage={props.scheduledHasNextPage}
              onPrevPage={props.userClickedScheduledPrevPage}
              onNextPage={props.userClickedScheduledNextPage}
            />
          </RhCard>
        </Section>
        <Section>
          <RhCard>
            <HorizontalContent
              left={<H2>Past Events</H2>}
              right={
                <RhInput
                  onChange={e => {
                    props.userUpdatedPastLiveEventsSearchField(e.target.value);
                  }}
                  icon={FiSearch}
                  placeholder="Search"
                />
              }
            />
            {!!props.pastEvents.length && (
              <Events>
                {props.pastEvents.map(event => (
                  <RhCardListItem
                    isHoverable
                    key={event.id}
                    imageUrl={event.featuredImage.url}
                    startTime={event.startTime}
                    title={event.title}
                    authorLabelOverride="Lead by:"
                    author={_.startCase(event.leader?.name)}
                    dateUpdated={event.dateUpdated}
                    description={event.description}
                    onClick={() => props.userClickedAnEvent(event.id)}
                    topRightActions={
                      event.theProgram.publishingStatus === 'unpublished' ? (
                        <RhTag editable={false} title="Unpublished" />
                      ) : null
                    }
                  />
                ))}
              </Events>
            )}
            <SectionListPagination
              loading={props.loading}
              currentPage={props.pastPage}
              hasNextPage={props.pastHasNextPage}
              onPrevPage={props.userClickedPastPrevPage}
              onNextPage={props.userClickedPastNextPage}
            />
          </RhCard>
        </Section>
      </Grid>
    </DashboardWrapper>
  );
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-gap: 20px;
`;

const Section = styled.div``;

const Events = styled.div`
  margin-top: 14px;
  & > :not(:last-child) {
    margin-bottom: 14px;
  }
`;
